import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=e88797ba&scoped=true&"
import script from "./EditPassword.vue?vue&type=script&lang=js&"
export * from "./EditPassword.vue?vue&type=script&lang=js&"
import style0 from "./EditPassword.vue?vue&type=style&index=0&id=e88797ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88797ba",
  null
  
)

export default component.exports